<template>
  <a
  :href="`https://taytbfest.visquares.com/tenants/${tenant.category_slug}/${tenant.slug}`"
  class="card bg-white rounded m-5 w-72 shadow-lg cursor-pointer overflow-hidden">
    <!--Banner image-->
    <img
      class="w-full tenant-img"
      :src="[tenant.logo ? tenant.logo : 'https://www.redairship.com/wp-content/uploads/2020/02/ocbc-logo-330-160.png' ]"
    />
    <!--Tag-->
    <div class="flex flex-col bottom-section">
      <div class=" flex items-center company-name ">
        <p class="text-gray-600 font-semibold pl-2">{{ tenant.company_name }}</p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Card',
  props: ['tenant']
}
</script>

<style>
  .card:hover {
    transition: all 0.3s;
    transform: scale(1.1, 1.1);
  }
  .card {
    /* border-radius: 10px; */
    height: 150px;
    box-shadow: 0 0.0625rem 0 0.125rem rgb(0, 0, 0 / 10%), 0 0.25rem 1rem -0.125rem rgb(0, 0, 0 / 15%);
    background-color: rgb(255, 255, 255);
    transition-timing-function: ease-in-out;
  }
  .tenant-img {
    height: 100px;
    border-radius: 10px 10px 0 0;
  }
  .company-name {
    height: 50px;
  }
</style>
